<template>
    <form-row title="List Date" section_id="list-date">
        <div class="sm:-mt-4 flex flex-col sm:flex-row flex-1 sm:flex-wrap lg:flex-nowrap">
            <div class="mt-2">
                <input-date
                    label="List Date"
                    name="list_date"
                    v-model="list_date"
                    :read_only="read_only"
                />
            </div>

            <div class="w-1/2 sm:w-auto sm:px-4 mt-2">
                <input-text
                    label="List Duration"
                    name="listing_duration"
                    placeholder="Days"
                    v-model="listing_duration"
                    :read_only="read_only"
                />
            </div>

            <div class="mt-2">
                <input-date
                    label="Expiration Date"
                    name="expire_date"
                    v-model="expire_date"
                    @entered="expireDateEntered"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
import DateFunctions from '../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        listing_detail: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            listing_duration: this.listing_detail.listing_duration,
            expire_date: this.listing_detail.expire_date,
        }
    },

    computed: {
        list_date: {
            get() {
                return store.state.list_date;
            },
            set(val) {
                store.state.list_date = val;
            },
        },
        expire_date_calculated() {
            if (! this.list_date) {
                return;
            }

            if (this.isValidDate(this.list_date) && this.listing_duration) {
                return dayjs(this.list_date.slice(0, 10))
                    .add({ day: this.listing_duration })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        expireDateEntered() {
            this.listing_duration = null;
        },
    },

    watch: {
        expire_date_calculated(val) {
            if (val) {
                this.expire_date = val;
            }
        },
    },
}
</script>
